import React, { useState, useEffect, useCallback } from "react";
import moment from "moment-timezone";
import { requestData } from "../services/requests";
import FiltrarDados from "../componentes/filtrarDados";
import Carteiras from "../componentes/carteiras";
import Header from "../componentes/header";
import { funcaoOrganizar } from "../services/funcoesAuxiliares";
import FiltrarDadosMobile from "../componentes/filtroMobile";
import { toast } from "react-toastify";

const Painel = () => {
  const [carteiras, setCarteiras] = useState([]);
  const [activeTab, setActiveTab] = useState("gestores");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [error, setError] = useState(false);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [isSingleColumn, setIsSingleColumn] = useState(() => {
    const savedLayout = localStorage.getItem("isSingleColumn");
    return savedLayout === "true";
  }); 
  const largura =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const [currentStep] = useState(1);

  const hoje = moment().format().split("T")[0];
  const mesPassado = moment().subtract(1, "month").format();
  const MesAnterior = mesPassado.split("T")[0];

  const getSearch = useCallback(
    async (activeTab, value, page, limit) => {
      const params = new URLSearchParams(value).toString();
      const response = await requestData(`/carteiras/filtro?${params}&page=${page}&limit=${limit}&tab=${activeTab}`);
      const organizarCarteiras = funcaoOrganizar(response.carteirasResult);
      return organizarCarteiras;
    },
    []
  );

  const getCarteiras = useCallback(
    async (activeTab, filtros = null, page, limit) => {
      try {
        setError(false);
        let response;

        if (filtros) {
          setIsFiltering(true);
          setCurrentFilters(filtros); // Armazena os filtros aplicados
          const params = new URLSearchParams(filtros).toString();
          response = `/carteiras/filtro?${params}&page=${page}&limit=${limit}&tab=${activeTab}`;
        } else {
          setIsFiltering(false);
          setCurrentFilters(null); // Limpa os filtros quando não há filtros
          response = `/carteiras/?&dataInicial=${MesAnterior}&dataFinal=${hoje}&tab=${activeTab}&page=${page}&limit=${limit}`;
        }

        const { carteirasResult, totalCount } = await requestData(response);
        const organizarCarteiras = funcaoOrganizar(carteirasResult);
        setTotalCount(totalCount);
        setCarteiras(organizarCarteiras);
      } catch (e) {
        setError(true);
        toast.warning("Nenhuma carteira cadastrada!");
        setTotalCount(0);
        setCarteiras([]);
      }
    },
    [hoje, MesAnterior]
  );

  useEffect(() => {
    // Só executa quando muda de tab, não quando muda de página
    getCarteiras(activeTab, currentFilters, page, limit);
  }, [activeTab]); // Removido page e limit das dependências

  // useEffect separado para mudança de tab
  useEffect(() => {
    setPage(1); // Reset para página 1 ao mudar de tab
    setCurrentFilters(null); // Limpa filtros ao mudar de tab
  }, [activeTab]);

  const toggleLayout = () => {
    setIsSingleColumn((prev) => {
      const newLayout = !prev;
      localStorage.setItem("isSingleColumn", newLayout);
      return newLayout;
    });
  };


  return (
    <>
      <Header toggleLayout={toggleLayout} largura={largura} isSingleColumn={isSingleColumn} />
      {largura >= 1000 ? (
        <FiltrarDados 
        setError={setError} 
        getCarteiras={getCarteiras}
        activeTab={activeTab}
        page={page}
        limit={limit}
        getSearch={getSearch}
        />
      ) : (
        <FiltrarDadosMobile
          setError={setError}
          getCarteiras={getCarteiras}
          activeTab={activeTab}
          page={page}
          limit={limit}
          getSearch={getSearch}
        />
      )}
      <Carteiras
        isSingleColumn={isSingleColumn}
        error={error}
        carteiras={carteiras}
        setCarteiras={setCarteiras}
        getCarteiras={getCarteiras}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        filtragem={isFiltering}
        page={page}
        limit={limit}
        setPage={setPage}
        setLimit={setLimit}
        totalCount={totalCount}
        currentFilters={currentFilters}
      />
    </>
  );
};

export default Painel;
